import React, { ReactElement, FC, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { MenuItem, Select, Typography, Pagination } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { MAIN_BLUE, WHITE_TEXT } from "../../color";

const theme = createTheme({
  palette: {
    primary: {
      main: MAIN_BLUE,
      contrastText: WHITE_TEXT,
    },
  },
});
const rowHeight = 40;

const GridItem = (props) => {
  const [gotData, setGotData] = React.useState(false);
  const [type, setType] = React.useState("");

  useEffect(() => { }, []);

  const handleChange = (event, value) => {
    props.setPage(value);
  };
  const getRowStyle = (params) => {
    if (params.node.rowIndex % 2 != 0) {
      return { background: "#F8F8F8" };
    }
  };

  return (
    <div className="ag-theme-alpine grid-container">
      <AgGridReact
        ref={props.gridRef}
        rowHeight={rowHeight}
        rowData={props.rowData}
        columnDefs={props.columnDefs}
        defaultColDef={props.defaultColDef}
        getRowStyle={getRowStyle}
        onGridReady={props.onGridReady}
        autoGroupColumnDef={props.autoGroupColumnDef}
        suppressRowClickSelection={props.suppressRowClickSelection}
        groupSelectsChildren={props.groupSelectsChildren}
        rowSelection={props.rowSelection}
        rowGroupPanelShow={props.rowGroupPanelShow}
        pivotPanelShow={props.pivotPanelShow}
        enableRangeSelection={props.enableRangeSelection}
        pagination={props.pagination}
        onSelectionChanged={props.onSelectionChanged}
        // rowModelType="serverSide"
        // serverSideStoreType="partial"
        onFilterChanged={props.onFilterChanged}
      />
      {props.pagination != false && (
        <ThemeProvider theme={theme}>
          <Pagination
            count={props.count}
            shape="rounded"
            color="primary"
            onChange={handleChange}
            page={props.page}
          />
        </ThemeProvider>
      )}
    </div>
  );
};

export default GridItem;
